<template>
  <div 
    :style="avatarStyle" 
    class="cliente-avatar"
    :class="[`avatar-${size}`, { 'clickable': clickable }]"
    @click="handleClick"
    :title="title"
  >
    {{ avatarText }}
  </div>
</template>

<script>
export default {
  name: 'ClienteAvatar',
  props: {
    nome: {
      type: String,
      required: true
    },
    identificacao: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'medium', // small, medium, large, xlarge
      validator: value => ['small', 'medium', 'large', 'xlarge'].includes(value)
    },
    clickable: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    avatarText() {
      return (this.nome || '').charAt(0).toUpperCase();
    },
    avatarStyle() {
      const str = (this.nome || '') + (this.identificacao || '');
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      const hue = (hash % 360 + 360) % 360;
      return {
        background: `hsl(${hue}, 65%, 44%)`,
        color: 'var(--text-primary)',
      };
    }
  },
  methods: {
    handleClick() {
      if (this.clickable) {
        this.$emit('click');
      }
    }
  }
};
</script>

<style scoped>
.cliente-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: var(--text-primary);
  flex-shrink: 0;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.cliente-avatar.clickable {
  cursor: pointer;
}

.cliente-avatar.clickable:hover {
  transform: scale(1.05);
  box-shadow: var(--shadow-md);
}

/* Tamanhos */
.avatar-small {
  width: 32px;
  height: 32px;
  font-size: 0.9rem;
}

.avatar-medium {
  width: 44px;
  height: 44px;
  font-size: 1.3rem;
}

.avatar-large {
  width: 56px;
  height: 56px;
  font-size: 1.6rem;
}

.avatar-xlarge {
  width: 80px;
  height: 80px;
  font-size: 2.2rem;
}
</style> 